module.exports = __webpack_public_path__ + "static/media/shape3.pngfeat1.c5439f12.png";